import {getHomeCountryPrice} from '@dazn/lp-web/src/utils/getHomeCountryPrice';
import {IChargeTier, PRICE_VARIABLE} from '@dazn/lp-web/src/types';
import {getPriceStrings} from '../components/BannerSlider/banner-slider.utils';

export const getOfferPrice = (
    chargeTierPrice: number,
    chargeTierCurrency: string,
    priceText: string
): {prefix: string; price: string; suffix: string} => {

    if (chargeTierPrice && chargeTierCurrency) {
        const homeCountryPrice =
            getHomeCountryPrice(chargeTierPrice, chargeTierCurrency) ?? 0;
        const price = homeCountryPrice.toString();
        const {prefix, suffix} = getPriceStrings(priceText, PRICE_VARIABLE);

        return {
            prefix,
            price,
            suffix
        };
    }
    return {
        prefix: '',
        price: '',
        suffix: ''
    };
};

export const getChargeTier = (chargeTiers: any, currency: any) => {
    return chargeTiers?.find(
        (chargeTier: IChargeTier) =>
            chargeTier?.Currency?.toLocaleLowerCase() ===
            currency?.toLocaleLowerCase()
    );
};
